import ResponsiveVideo from './ResponsiveVideo';

export default class Videos {
	constructor() {
		if (!'IntersectionObserver' in window) {
			return;
		}
		this.observer = new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '200px' });
		this.breakpoint = window.matchMedia('(max-width:567px)');

		document.addEventListener('bless', e => {
			this.container = e.detail.element;
			this.init(this.container);
		});
	}

	init(container) {
		const videos = container.querySelectorAll('video');
		this.observeVideos(videos);
	}

	observeVideos(videos) {
		videos.forEach(video => {
			if (video.dataset.autoplay) {
				new ResponsiveVideo(video);
				this.observer.observe(video);
			}
		});
	}

	handleIntersection(entries) {
		entries.forEach(entry => {
			const ratio = entry.intersectionRatio;
			const target = entry.target;
			const isPlaying = !target.paused;

			// Video is in viewport
			if (ratio > 0) {
				target.dispatchEvent(new CustomEvent('play-video'));
			}

			// Video is outside viewport and ready to be paused
			if (isPlaying && (ratio <= 0 || ratio > 1)) {
				target.dispatchEvent(new CustomEvent('pause-video'));
			}
		});
	}

}
